export enum API {
    CreateDb = "createDb",
    IsDbExist = "isDbExist",
    GetDbVersion = "getDbVersion",
    GetDbList = "getDbList",
    Get = "get",
    Set = "set",
    Select = "select",
    Insert = "insert",
    Update = "update",
    Remove = "remove",
    GetDbSchema = "getDbSchema",
    OpenDb = "openDb",
    Clear = "clear",
    DropDb = "dropDb",
    Count = "count",
    BulkInsert = "bulkInsert",
    ExportJson = "exportJson",
    ChangeLogStatus = "changeLogStatus",
    Transaction = "transaction",
    RunSql = "runSql"
}